import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback
} from './utils'

export const INITIAL_STATE = {
  sendEmailShare: initialFeedback()
}

const { Types, Creators } = createActions(
  {
    sendEmailShare: ['data'],
    sendEmailShareSuccess: ['data'],
    sendEmailShareFailure: ['errors']
  },
  { prefix: 'SOCIAL_SHARE_' }
)

export const SocialShareActionTypes = Types
export const SocialShareActionCreators = Creators

const sendEmailShareRequest = state => ({
  ...state,
  sendEmailShare: requestFeedback()
})

const sendEmailShareSuccess = (state, { data }) => ({
  ...state,
  sendEmailShare: successFeedback(data)
})

const sendEmailShareFailure = (state, { errors }) => ({
  ...state,
  sendEmailShare: failureFeedback(errors)
})

export default createReducer(INITIAL_STATE, {
  [Types.SEND_EMAIL_SHARE]: sendEmailShareRequest,
  [Types.SEND_EMAIL_SHARE_SUCCESS]: sendEmailShareSuccess,
  [Types.SEND_EMAIL_SHARE_FAILURE]: sendEmailShareFailure
})
